export const appInfo={
    name:'Guardians Collective',
    description:'Protect What You Love',
    title:'Guardians Collective',
    comingSoon:process.env['NODE_ENV']==='production',
} as const;